import Head from 'next/head'
import { sanityClient } from '@bww/beke-lib/sanity-client'
import YourDreamCTA from '@bww/beke-ui/YourDreamCTA'
import PageHeaderBanner, { HeaderTextBlock } from '@bww/beke-ui/PageHeader'
import InspirationList from '@bww/beke-ui/Inspiration/InspirationList'
import Link from 'next/link'

export default function InspirationPage({ items }) {
  const year = new Date().getFullYear()
  return (
    <>
      <Head>
        <title>Bathroom Design Inspiration</title>
        <meta
          name="description"
          content={`Design insights and ${year}'s best bathroom design trends and innovations, curated by the Bathroom Elegance team.`}
        />
      </Head>
      <PageHeaderBanner
        title="Bathroom Inspiration"
        categoryTitle="Innovations and insights"
        noMargin
      />
      <div
        style={{
          background:
            'linear-gradient(to bottom, var(--color-alt-tint-light), rgb(220,220,220) 400px)',
          borderTop: '1px solid #fff',
          borderBottom: '1px solid #ddd',
          paddingBlock: '50px 80px',
        }}
      >
        <div className="container">
          <HeaderTextBlock>
            <p>
              Fuel your creativity with this selection of inspiring ideas and
              innovative products from our range.
              <br />
              Our <Link href="/poole-showroom">showroom in Poole</Link> features
              50 display areas for the ultimate browsing experience.
            </p>
          </HeaderTextBlock>
          <InspirationList items={items} />
        </div>
      </div>
      <YourDreamCTA ctaText="Seen something you like?" />
    </>
  )
}

export async function getStaticProps() {
  const items = await sanityClient.fetch(
    `*[_id == "be-inspiration"].items[0...12]->{
      _type == 'project' => {
        "type": _type,
        title,
        "slug": slug.current,
        "image": images[0]{ ..., "lqip": asset->metadata.lqip },
        shortDescription
      },
      _type == "insight" => {
        "type": _type,
        title,
        "slug": slug.current,
        image{ ..., "lqip": asset->metadata.lqip },
        description
      },
      _type == 'product-feature' => {
        "type": _type,
        title,
        "slug": slug.current,
        "image": images[0]{ ..., "lqip": asset->metadata.lqip },
        description,
        brand->{
          name,
          "slug": slug.current,
          logo{ "src": asset->url }
        }
      },
    }`,
  )

  return {
    props: {
      items,
    },
  }
}
